import { FC } from "react";
import { Box, Typography } from "@mui/material";

import ChevronRightIcon from "../../../../icons/ChevronRightIcon";

import { ClaimAppeal } from "../../../../../types/claims";
import { formatDisplayDate } from "../../../../helpers/dataHelper";
import Row from "../../../../ui/core/Row";
import CardChip from "../CardChip";
import { getCardSx } from "../ediCardStyles";
import {
  ACTION_TYPE_LABELS,
  actionCaption,
  actionTitle,
} from "../claimAppeals";
import { claimTag } from "../claim-link/claimLinks";

// One recorded action in the Claim timeline: what, when, to which payer, and
// on a linked correct and resubmit the corrected claim (REV-2629)
const AppealCard: FC<{
  appeal: ClaimAppeal;
  onClick: () => void;
}> = ({ appeal, onClick }) => (
  <Box
    onClick={onClick}
    role="button"
    tabIndex={0}
    onKeyDown={(e) => {
      if (e.key === "Enter" || e.key === " ") onClick();
    }}
    sx={getCardSx("custom.cardBorder")}
  >
    <Box sx={{ minWidth: 0 }}>
      <Row sx={{ alignItems: "center", gap: 1 }}>
        <Typography sx={{ fontSize: "0.8125rem", fontWeight: 600 }}>
          {actionTitle(appeal)}
        </Typography>
        {appeal.actionType === "dofr" && (
          <CardChip
            chip={{ label: ACTION_TYPE_LABELS.dofr, kind: "default" }}
          />
        )}
      </Row>

      <Typography
        variant="caption"
        color="text.secondary"
        noWrap
        component="div"
        sx={{ fontSize: "0.7rem", paddingTop: "7px" }}
      >
        {actionCaption(appeal, formatDisplayDate)}
      </Typography>
      {appeal.link && (
        <Typography
          noWrap
          component="div"
          sx={{
            fontSize: "0.75rem",
            fontWeight: 600,
            color: "info.main",
            pt: 0.25,
          }}
        >
          Resubmitted as {claimTag(appeal.link.childClaimNumber)}
        </Typography>
      )}
    </Box>

    <ChevronRightIcon className="w-4 h-4 text-gray-400 shrink-0" />
  </Box>
);

export default AppealCard;
